import React from "react";
import { Pie, PieChart, Tooltip } from "recharts";

const Bookingoverview = () => {
  const revenueOverviewData = {
    title: "Revenue Snapshot",
    titleIcon: "performanceOverview",
    counts: [
      {
        title: "Total Revenue",
        value: 4545,
      },
      {
        title: "Cost to Company",
        value: 6767,
      },
      {
        title: "Cancel Revenue Recovered",
        value: 3434,
      },
    ],
  };

  const bookingHealthOverviewData = {
    title: "Booking Health",
    titleIcon: "performanceOverview",
    counts: [
      {
        title: "Total Bookings",
        value: 4545,
      },
      {
        title: "Confirmed Bookings",
        value: 6767,
      },
      {
        title: "Closed Bookings",
        value: 3434,
      },
    ],
  };

  const cancellationOverviewData = {
    title: "Cancellations",
    titleIcon: "performanceOverview",
    counts: [
      {
        title: "Admin Cancellations",
        value: 4545,
        loss: 87987,
      },
      {
        title: "User Cancellations",
        value: 6767,
        loss: 121,
      },
      {
        title: "Total Cancellations",
        value: 3434,
        loss: 67,
      },
    ],
  };

  const revenueLeakageOverviewData = {
    title: "Revenue Leakage",
    titleIcon: "performanceOverview",
    countsOne: [
      {
        title: "Cancellation Rev loss",
        value: 4545,
        loss: null,
      },
      {
        title: "Recovery Pending",
        value: 6767,
        loss: 9 + " Cases",
      },
    ],
    countsTwo: [
      {
        title: "Verification Pending",
        value: 12,
      },
      {
        title: "Document Pending",
        value: 44,
      },
    ],
  };

  return (
    <div>
      <div className="w-full self-stretch p-8 inline-flex flex-col justify-start items-center">
        <div className="self-stretch flex flex-col justify-center items-start gap-6">
          <div className="self-stretch inline-flex justify-center items-center gap-4">
            <div className="flex-1 px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-center items-center gap-6">
              <div className="self-stretch bg-green-700 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                    <div className="size-6 relative overflow-hidden">
                      <div className="size-5 left-[1.75px] top-[1.75px] absolute bg-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    {revenueOverviewData?.title}
                  </div>
                </div>
              </div>
              <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
                {revenueOverviewData &&
                  revenueOverviewData?.counts.map((data, index) => (
                    <div className="flex-1 h-48 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                      <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                        <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                          {data?.title}
                        </div>
                      </div>
                      <div className="self-stretch h-16 flex flex-col justify-center items-center">
                        <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                          {"₹" + data?.value}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="self-stretch inline-flex justify-center items-start gap-4">
            <div className="flex-1 self-stretch px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-start items-center gap-4">
              <div className="self-stretch bg-blue-400 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                    <div className="size-6 relative overflow-hidden">
                      <div className="w-4 h-5 left-[3px] top-[2px] absolute bg-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    {bookingHealthOverviewData?.title}
                  </div>
                </div>
              </div>
              <div className="self-stretch flex-1 px-4 py-2 flex flex-col justify-center items-start gap-4">
                {bookingHealthOverviewData &&
                  bookingHealthOverviewData.counts.map((data, index) => (
                    <div className="self-stretch flex-1 p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-between items-start">
                      <div className="w-44 justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                        {data?.title}
                      </div>
                      <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                        {data?.value}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="w-px h-48 bg-zinc-400"></div>
            <div className="w-[740px] h-64 my-2 px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-center items-center gap-4">
              <div className="self-stretch bg-blue-700 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                    <div className="size-6 relative overflow-hidden">
                      <div className="size-5 left-[1.75px] top-[1.75px] absolute bg-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    Revenue - Value
                  </div>
                </div>
              </div>
              <div className="self-stretch px-4 py-1 inline-flex justify-start items-center gap-6">
                <div className="flex-1 h-48 px-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 flex justify-between items-center">
                  <div className="size- inline-flex flex-col justify-start items-start gap-2">
                    <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                      <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                        Weekday revenue
                      </div>
                    </div>
                    <div className="self-stretch h-16 flex flex-col justify-center items-center">
                      <div className="justify-start text-blue-600 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                        ₹8,22,640
                      </div>
                    </div>
                    <div className="justify-start text-slate-400 text-sm font-medium font-['Outfit'] leading-5">
                      5 days · avg ₹1,26,504/day
                    </div>
                  </div>
                  <div className="size-40 relative">
                    <div className="size-40 left-[-1.55px] top-[-2.60px] absolute bg-blue-600 rounded-full" />

                    <PieChart
                      accessibilityLayer
                      activeShape={{
                        fill: "red",
                      }}
                      barCategoryGap="10%"
                      barGap={4}
                      cx="50%"
                      cy="50%"
                      data={[
                        {
                          amt: 822640,
                          fill: "#8884d8",
                          name: "18-24",
                          pv: 2400,
                          uv: 31.47,
                        },

                        {
                          amt: 634480,
                          fill: "#ffc658",
                          name: "unknown",
                          pv: 4800,
                          uv: 6.67,
                        },
                      ]}
                      endAngle={360}
                      innerRadius={0}
                      layout="centric"
                      margin={{
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0,
                      }}
                      outerRadius="80%"
                      stackOffset="none"
                      startAngle={0}
                      syncMethod="index"
                      throttleDelay="raf"
                      throttledEvents={[
                        "mousemove",
                        "touchmove",
                        "pointermove",
                        "scroll",
                        "wheel",
                      ]}
                    >
                      <Pie
                        data={[
                          {
                            amt: 822640,
                            fill: "#8884d8",
                            name: "18-24",
                            pv: 2400,
                            uv: 31.47,
                          },

                          {
                            amt: 634480,
                            fill: "#ffc658",
                            name: "unknown",
                            pv: 4800,
                            uv: 6.67,
                          },
                        ]}
                        dataKey="uv"
                        shape={function _9() {}}
                      />
                      <Tooltip defaultIndex={3} />
                    </PieChart>
                    <div className="left-[41px] top-[61.50px] absolute text-center justify-start text-slate-500 text-xl font-medium font-['Outfit'] leading-4 tracking-tight">
                      Revenue
                      <br />
                      Split
                    </div>
                  </div>
                  <div className="size- inline-flex flex-col justify-start items-start gap-2">
                    <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                      <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                        Weekend revenue
                      </div>
                    </div>
                    <div className="self-stretch h-16 flex flex-col justify-center items-center">
                      <div className="justify-start text-green-500 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                        ₹6,34,480
                      </div>
                    </div>
                    <div className="justify-start text-gray-400 text-sm font-medium font-['Outfit']">
                      2 days · avg ₹3,17,240/day
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch h-44 inline-flex justify-center items-start gap-4">
            <div className="flex-1 self-stretch px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-start items-center gap-4">
              <div className="self-stretch bg-blue-400 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                    <div className="size-6 relative">
                      <div className="size-5 left-[2px] top-[2px] absolute bg-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    {cancellationOverviewData?.title}
                  </div>
                </div>
              </div>
              <div className="self-stretch flex-1 px-4 py-2 inline-flex justify-start items-center gap-4">
                {cancellationOverviewData &&
                  cancellationOverviewData.counts.map((data, index) => (
                    <div className="flex-1 self-stretch p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-start">
                      <div className="self-stretch inline-flex justify-between items-start">
                        <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                          {data?.title}
                        </div>
                        <div className="justify-start text-neutral-700 text-2xl font-normal font-['Days_One'] leading-5 tracking-wide">
                          {data?.value}
                        </div>
                      </div>
                      <div className="self-stretch text-right justify-start text-slate-400 text-sm font-medium font-['Outfit'] leading-5">
                        ₹{data?.loss} loss
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="self-stretch h-60 px-1 pb-2 bg-red-400/20 rounded-3xl flex flex-col justify-start items-center gap-6">
            <div className="self-stretch bg-red-600 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
              <div className="self-stretch flex justify-start items-center gap-4">
                <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                  <div className="size-6 relative overflow-hidden">
                    <div className="size-1.5 left-[16.29px] top-[11.14px] absolute outline outline-2 outline-offset-[-1px] outline-black" />
                    <div className="w-6 h-3 left-[0.86px] top-[6px] absolute outline outline-2 outline-offset-[-1px] outline-black" />
                  </div>
                </div>
                <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                  {revenueLeakageOverviewData?.title}
                </div>
              </div>
            </div>
            <div className="self-stretch flex-1 px-4 py-2 flex flex-col justify-center items-start gap-6">
              <div className="self-stretch flex-1 inline-flex justify-start items-start gap-6">
                {revenueLeakageOverviewData &&
                  revenueLeakageOverviewData?.countsOne.map((data, index) => (
                    <div className="flex-1 h-36 p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                      <div className="size- flex flex-col justify-start items-start gap-7">
                        <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                          {data?.title}
                        </div>
                        <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                          ₹{data?.value}
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="w-px h-32 bg-zinc-400"></div>{" "}
                {revenueLeakageOverviewData &&
                  revenueLeakageOverviewData.countsTwo.map((data, index) => (
                    <div className="flex-1 h-36 p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-start">
                      <div className="w-44 justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                        {data?.title}
                      </div>
                      <div className="self-stretch h-16 flex flex-col justify-center items-center">
                        <div className="justify-start text-neutral-700 text-5xl font-normal font-['Days_One'] leading-5 tracking-wide">
                          {data?.value}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="w-[1376px] inline-flex justify-center items-center gap-4">
            <div className="w-[850px] self-stretch px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-start items-center gap-6">
              <div className="self-stretch bg-orange-500 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-red-400 flex justify-center items-center">
                    <div className="size-6 relative overflow-hidden">
                      <div className="size-4 left-[3px] top-[3px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    Booking Source
                  </div>
                </div>
              </div>
              <div className="self-stretch flex-1 px-4 py-2 inline-flex justify-start items-center gap-6">
                <div className="flex-1 self-stretch p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-center">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Website Bookings
                  </div>
                  <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    236
                  </div>
                  <div className="justify-end text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                    ₹6,05,360
                  </div>
                </div>
                <div className="flex-1 self-stretch p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-center">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    App Bookings
                  </div>
                  <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    200
                  </div>
                  <div className="justify-end text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                    ₹5,42,080
                  </div>
                </div>
                <div className="flex-1 self-stretch p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-center">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Admin Bookings
                  </div>
                  <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    89
                  </div>
                  <div className="justify-end text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                    ₹3,32,080
                  </div>
                </div>
              </div>
            </div>
            <div className="w-px h-32 bg-zinc-400"></div>
            <div className="w-[400px] flex-1 h-60 px-1 pb-2 bg-red-400/20 rounded-3xl inline-flex flex-col justify-start items-center gap-6">
              <div className="self-stretch bg-cyan-600 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
                <div className="self-stretch flex justify-start items-center gap-4">
                  <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-neutral-500 flex justify-center items-center">
                    <div className="size-6 relative">
                      <div className="w-1 h-2 left-[10px] top-[8px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-black" />
                      <div className="w-4 h-5 left-[3px] top-[2px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-black" />
                    </div>
                  </div>
                  <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                    Security Deposits
                  </div>
                </div>
              </div>
              <div className="self-stretch flex-1 px-4 py-2 flex flex-col justify-center items-start gap-6">
                <div className="self-stretch flex-1 inline-flex justify-start items-start gap-6">
                  <div className="flex-1 h-36 p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-start">
                    <div className="w-44 justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                      Deposit Count
                    </div>
                    <div className="self-stretch h-16 flex flex-col justify-center items-start">
                      <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                        273
                      </div>
                    </div>
                  </div>
                  <div className="flex-1 h-36 p-4 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-between items-start">
                    <div className="w-44 justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                      Collected Amount
                    </div>
                    <div className="self-stretch h-16 flex flex-col justify-center items-start">
                      <div className="justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                        ₹9,71,600
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch px-1 pb-2 bg-yellow-600/20 rounded-3xl flex flex-col justify-center items-center gap-6">
            <div className="self-stretch bg-yellow-700 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
              <div className="self-stretch flex justify-start items-center gap-4">
                <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-yellow-600 flex justify-center items-center">
                  <div className="size-6 relative overflow-hidden">
                    <div className="w-3.5 h-[3px] left-[5px] top-[12px] absolute bg-black" />
                    <div className="w-5 h-4 left-[1.99px] top-[3.01px] absolute bg-black" />
                  </div>
                </div>
                <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                  Vehicle revenue by category
                </div>
              </div>
            </div>
            <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-6">
              <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-6">
                <div className="w-36 justify-start text-slate-500 text-base font-semibold font-['Outfit'] leading-5">
                  Hatchback
                </div>
                <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  ₹6,37,280
                </div>
              </div>
              <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-6">
                <div className="w-36 justify-start text-slate-500 text-base font-semibold font-['Outfit'] leading-5">
                  Sedan
                </div>
                <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  ₹5,05,680
                </div>
              </div>
              <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-6">
                <div className="w-36 justify-start text-slate-500 text-base font-semibold font-['Outfit'] leading-5">
                  Crossover SUV
                </div>
                <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  ₹2,11,960
                </div>
              </div>
              <div className="flex-1 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-6">
                <div className="w-36 justify-start text-slate-500 text-base font-semibold font-['Outfit'] leading-5">
                  SUV
                </div>
                <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                  ₹3,06,880
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch px-1 pb-2 bg-slate-400/20 rounded-3xl flex flex-col justify-center items-center gap-6">
            <div className="self-stretch bg-green-500 rounded-2xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.24)] inline-flex justify-start items-center gap-2">
              <div className="self-stretch flex justify-start items-center gap-4">
                <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-teal-900 flex justify-center items-center">
                  <div className="size-6 relative">
                    <div className="w-4 h-3 left-[3px] top-[6px] absolute outline outline-2 outline-offset-[-1px] outline-black" />
                    <div className="size-1 left-[10px] top-[10px] absolute outline outline-2 outline-offset-[-1px] outline-black" />
                    <div className="size-1.5 left-[15px] top-[3px] absolute outline outline-2 outline-offset-[-1px] outline-black" />
                  </div>
                </div>
                <div className="justify-start text-white text-xl font-semibold font-['Outfit'] leading-5 tracking-wide">
                  Add-on Charges
                </div>
              </div>
            </div>
            <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-4">
              <div className="flex-1 h-48 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Fuel Charges
                  </div>
                </div>
                <div className="self-stretch h-16 flex flex-col justify-center items-center">
                  <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    ₹2,37,440
                  </div>
                </div>
              </div>
              <div className="flex-1 h-48 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Extra Hours
                  </div>
                </div>
                <div className="self-stretch h-16 inline-flex justify-center items-center gap-4">
                  <div className="flex-1 justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    476
                  </div>
                  <div className="justify-end text-gray-400 text-2xl font-black font-['DM_Sans'] leading-5 tracking-wide">
                    hrs
                  </div>
                </div>
                <div className="self-stretch text-right justify-start text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                  ₹3,72,680
                </div>
              </div>
              <div className="flex-1 h-48 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Extra KM
                  </div>
                </div>
                <div className="self-stretch h-16 inline-flex justify-center items-center gap-4">
                  <div className="flex-1 justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    1,680
                  </div>
                  <div className="justify-end text-gray-400 text-2xl font-black font-['DM_Sans'] leading-5 tracking-wide">
                    Km
                  </div>
                </div>
                <div className="self-stretch text-right justify-start text-slate-500 text-base font-medium font-['Outfit'] leading-5">
                  ₹1,27,960
                </div>
              </div>
              <div className="flex-1 h-48 p-5 bg-white rounded-2xl shadow-[inset_0px_1px_2px_-1px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch h-9 pb-4 inline-flex justify-start items-start">
                  <div className="justify-start text-slate-500 text-lg font-semibold font-['Outfit'] leading-5">
                    Fastag Penalty
                  </div>
                </div>
                <div className="self-stretch h-16 flex flex-col justify-center items-center">
                  <div className="self-stretch justify-start text-neutral-700 text-3xl font-normal font-['Days_One'] leading-5 tracking-wide">
                    ₹4,33,160
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookingoverview;
